import { scheduleAutoBootstrap } from './auto-init';
import type {
    VotiqContextOptions,
    VotiqInitOptions,
    VotiqInstance,
} from './types';
import {
    destroyWidget,
    initWidget,
    openWidget,
    setWidgetContext,
    updateWidget,
} from './widget';

export type {
    VotiqContextOptions,
    VotiqInitOptions,
    VotiqInstance,
    VotiqTabsConfig,
    WidgetContextResponse,
} from './types';

const Votiq = {
    init(options: VotiqInitOptions): VotiqInstance {
        return initWidget(options);
    },
    update(options: Partial<VotiqInitOptions>): void {
        updateWidget(options);
    },
    context(options: VotiqContextOptions | string): void {
        setWidgetContext(options);
    },
    destroy(): void {
        destroyWidget();
    },
    open(): void {
        openWidget();
    },
};

declare global {
    interface Window {
        Votiq: typeof Votiq;
    }
}

if (typeof window !== 'undefined') {
    window.Votiq = Votiq;
    scheduleAutoBootstrap();
}

export default Votiq;
